module.exports = __webpack_public_path__ + "img/t5-img2.982c208a.png";